import type { PropsWithChildren, ReactElement } from 'react';
import { Drawer, DrawerClose, DrawerContent } from '@/components/ui/drawer';
import { DismissCloseButton } from '@/components/ui/dismiss-close-button';
import { cn } from '@/lib/utils';

type CommerceNotificationDrawerProps = PropsWithChildren<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    closeAriaLabel: string;
    className?: string;
}>;

/** Bottom drawer shell for mobile commerce feedback. */
export function CommerceNotificationDrawer({
    open,
    onOpenChange,
    closeAriaLabel,
    className,
    children,
}: CommerceNotificationDrawerProps): ReactElement {
    return (
        <Drawer direction="bottom" open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
            <DrawerContent showDivider={false} className={cn('border-sand-95 bg-neutral-white', className)}>
                <div className="relative flex min-h-0 flex-1 flex-col px-6 pt-6 pb-8">
                    <div role="status" aria-live="polite" className="w-full [&_p:first-of-type]:pr-8">
                        {children}
                    </div>

                    <div className="absolute top-6 right-6">
                        <DrawerClose asChild>
                            <DismissCloseButton aria-label={closeAriaLabel} className="h-fit" />
                        </DrawerClose>
                    </div>
                </div>
            </DrawerContent>
        </Drawer>
    );
}
